// این فایل به‌صورت خودکار تمام فایل‌های ترجمه‌ی پنل مدیریت را از همین پوشه
// جمع‌آوری می‌کند (هر کامپوننت یک فایل جدا: admin/<ComponentName>.js).
// به همین دلیل افزودن ترجمه‌ی یک کامپوننت جدید نیازی به ویرایش این فایل ندارد
// (و بنابراین چند نفر/ایجنت می‌توانند هم‌زمان و بدون تداخل فایل جدید اضافه کنند).
//
// هر فایل کامپوننت باید یک export default به شکل زیر داشته باشد:
//   export default {
//     fa: { key: '...' }, en: { key: '...' }, de: {...}, es: {...},
//     fr: {...}, it: {...}, ja: {...}, ko: {...}, pt: {...}, hi: {...}, zh: {...}
//   }
import commonDict from './common';

export const ADMIN_LANGUAGES = ['fa', 'en', 'de', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'hi', 'zh'];

// require.context یک ویژگی webpack/CRA است؛ همه‌ی فایل‌های *.js همین پوشه
// (به‌جز index.js و common.js) را در build-time پیدا و import می‌کند.
const context = require.context('.', false, /^\.\/(?!index\.js$|common\.js$)[^./]+\.js$/);

const merged = {};
ADMIN_LANGUAGES.forEach((lang) => {
  merged[lang] = { common: commonDict[lang] || {} };
});

context.keys().forEach((key) => {
  const componentName = key.replace('./', '').replace(/\.js$/, '');
  const mod = context(key);
  const dict = mod && mod.default ? mod.default : mod;
  if (!dict) return;

  ADMIN_LANGUAGES.forEach((lang) => {
    if (dict[lang]) {
      merged[lang][componentName] = dict[lang];
    }
  });
});

export default merged;
